import { defineComponent } from 'vue';
import store from '@/store';
import { CustomError } from '../models/Error';
import { mapGetters } from 'vuex';

export default defineComponent({
  data: function () {
    return {
      isLoading: false,
      isSuccess: false,
      isError: false,
      errors: [] as string[],
      errorObjects: [] as CustomError[],
      v$: null as any,
    };
  },
  computed: {
    showFormMessages(): boolean {
      return this.isSuccess || this.isError || this.errors.length > 0;
    },
    ...mapGetters(['isMobile']),
  },
  methods: {
    success(scrollToMessages = true) {
      this.isSuccess = true;
      if (scrollToMessages) {
        this.scrollToMessages();
      }
    },
    startLoading() {
      this.isLoading = true;
    },
    endLoading() {
      this.isLoading = false;
    },
    getApiErrors(error: any): CustomError[] {
      const errors: CustomError[] = [];
      if (error && error.response && error.response.status === 400) {
        const result = error.response.data;
        if (result.errors) {
          Object.keys(result.errors).forEach((key) => {
            if (key === 'user.missing') {
              store.dispatch('logout');
            }
            for (const errorMessage of result.errors[key]) {
              errors.push({ code: key, message: errorMessage });
            }
          });
        } else if (result.modelErrors && result.modelErrors.length > 0) {
          for (let i = 0; i < result.modelErrors.length; i++) {
            errors.push({ message: result.modelErrors[i].errorMessage });
          }
        } else if (result.title) {
          errors.push({ message: result.title });
        }
      }
      if (errors.length === 0) {
        errors.push({ message: 'Error' });
      }
      return errors;
    },
    handleApiError(error: any) {
      this.errorObjects = this.getApiErrors(error);
      this.errors = this.errorObjects.map((x) => x.message.replace(/\r\n/g, '<br>'));
      if (this.errors.length === 0) {
        this.isError = true;
      }
      this.scrollToError();
    },
    scrollToError() {
      this.$nextTick(() => {
        const node = this.$el.querySelector ? this.$el : this.$el.parentNode;
        //let domRect = null as any;
        const validationMessage = node.querySelector('.is-danger, .form-error');
        if (validationMessage) {
          //domRect = validationMessage.getBoundingClientRect();
          validationMessage.scrollIntoView({ behavior: 'smooth' });
        } else {
          const flashMessage = node.querySelector('.flash-danger');
          if (flashMessage) {
            //domRect = flashMessage.getBoundingClientRect();
            flashMessage.scrollIntoView({ behavior: 'smooth' });
          }
        }
        //if (domRect) {
        // window.scrollTo({
        //   top: domRect.top + document.documentElement.scrollTop - 67,
        //   left: domRect.left + document.documentElement.scrollLeft,
        //   behavior: 'smooth',
        // });
        //}
      });
    },
    scrollToMessages() {
      this.$nextTick(() => {
        const node = this.$el.querySelector ? this.$el : this.$el.parentNode;
        //let domRect = null as any;
        const flashMessage = node.querySelector('.form-messages');
        if (flashMessage) {
          //domRect = flashMessage.getBoundingClientRect();
          flashMessage.scrollIntoView({ behavior: 'smooth', block: this.isMobile ? 'start' : 'center' });
        }
        // if (domRect) {
        //   window.scrollTo({
        //     top: domRect.top + document.documentElement.scrollTop - 67,
        //     left: domRect.left + document.documentElement.scrollLeft,
        //     behavior: 'smooth',
        //   });
        // }
      });
    },
    validate(): boolean {
      this.isSuccess = false;
      this.isError = false;
      this.errors = [];
      if (this.v$) {
        this.v$.$touch();
        if (this.v$.$invalid) {
          this.isError = true;
          this.scrollToError();
          return false;
        }
      }
      return true;
    },
  },
});
